import { render, staticRenderFns } from "./InfoGame.vue?vue&type=template&id=1fde6a42&scoped=true&"
import script from "./InfoGame.vue?vue&type=script&lang=js&"
export * from "./InfoGame.vue?vue&type=script&lang=js&"
import style0 from "./InfoGame.vue?vue&type=style&index=0&id=1fde6a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde6a42",
  null
  
)

export default component.exports